<script>

export default {
  name: 'CopyrightPage',
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog
    v-model="visible"
    persistent
    max-width="1000px"
  >
    <v-card>
      <v-card-title class="title pa-3" style="margin-left: 0px;">
        Impressum
        <v-spacer/>

        <v-btn @click="close" fab small flat>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12>
              <h3>Diese Webseite wird publiziert von</h3>
              EDIT Systems GmbH<br>
              <br>
              <h3>Kontakt</h3>
              EDIT Systems GmbH<br>
              Harkortstr.<br>
              6345145 Essen<br>
              <br>
              Telefon: +49 201 360396-0<br>
              Telefax: +49 201 360396-29<br>
              info@editsystems.com<br>
              <br>
              <h3>Geschäftsführer</h3>
              Selçuk Acar<br>
              <br>
              <h3>Handelsregister</h3>
              Registergericht: Amtsgericht Essen<br>
              Registernummer: HRB 25912<br>
              <br>
              <h3>Streitschlichtung</h3>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:
              <a target="_blank" href="https://ec.europa.eu/consumers/odr">
                https://ec.europa.eu/consumers/odr
              </a><br>
              Wir sind nicht bereit oder verpflichtet,
              an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.<br>
              <br>
              <h3>Haftungsausschluss</h3>
              <b>Haftung für Inhalte</b><br>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
              Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§
              8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
              übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
              Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.<br>
              <br>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
              Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt
              der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
              wir diese Inhalte umgehend entfernen.<br>
              <br>
              <b>Haftung für Links</b><br>
              Unser Angebot enthält Links zu externen Websites Dritter,
              auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
              Für die Inhalte der verlinkten Seiten ist stets der jeweilige
              Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten
              Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
              Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.<br>
              <br>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
              Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
              Links umgehend entfernen.<br><br>
              <b>Urheberrecht</b><br>
              Die durch die Seitenbetreiber erstellten
              Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
              Die Vervielfältigung, Bearbeitung,
              Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
              Urheberrechtes bedürfen der schriftlichen Zustimmung des
              jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten,
              nicht kommerziellen Gebrauch gestattet.<br>
              <br>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
              werden die Urheberrechte Dritter beachtet.
              Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
              Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
              Inhalte umgehend entfernen.<br>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
<style>
  h3 {
    padding-bottom: 0.3em;
  }
</style>
